import { Button as AntdButton, ButtonProps, ConfigProvider } from 'antd';
import React, { FC } from 'react';
import './button.style.scss';

export const Button: FC<ButtonProps> = (props) => {
    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: "#205BFC",
                colorPrimaryText: "#FFFFFF",
                colorPrimaryBorder: "#205BFC",
                colorBorder: "#D2DEFE",
            },
        }}>
        <AntdButton {...props} className={`rounded-[28px] disabled:bg-primary-20 disabled:text-primary-100 text-base flex items-center px-5 h-14 max-lg:h-12 max-lg:text-sm ${props.className ? props.className : ''}`} />
        </ConfigProvider>
    );
};